import service from '@/router/axios'

export const getChannelDashboard = (params) => {
  return service({
    url: '/report/media/channel/dashboard',
    method: 'get',
    params
  })
}

export const getMatDashboard = (params) => {
  return service({
    url: '/report/admin/mat/dashboard',
    method: 'get',
    params
  })
}


// 判断是否有主体信息
export const isSubjectInfo = () => {
  return service({
    url: '/subjectInfo/get/channel/info'
  })
}

// 修改选择渠道主体信息
export const updateSubjectInfo = (params) => {
  return service({
    url: '/subjectInfo/update/channel/info',
    params
  })
}